var map = {
	"./IMG-20240729-WA0023.jpg": 1965,
	"./IMG-20240729-WA0027.jpg": 7969,
	"./IMG-20240729-WA0028.jpg": 6858,
	"./IMG-20240729-WA0029.jpg": 8247,
	"./IMG-20240729-WA0030.jpg": 7673,
	"./IMG-20240729-WA0039.jpg": 9732,
	"./IMG-20240729-WA0040.jpg": 9860,
	"./IMG-20240729-WA0042.jpg": 5814,
	"./IMG-20240729-WA0044.jpg": 6336,
	"./IMG-20240729-WA0051.jpg": 5718,
	"./IMG-20240729-WA0054.jpg": 4287,
	"./IMG-20240729-WA0057.jpg": 3968,
	"./IMG-20240729-WA0064.jpg": 3418,
	"./WhatsApp Image 2024-07-29 at 11.44.32_85bbe963.jpg": 9723,
	"./WhatsApp Image 2024-09-16 at 10.47.34.jpeg": 2223,
	"./WhatsApp Image 2024-09-16 at 10.51.02.jpeg": 1591,
	"./WhatsApp Image 2024-09-16 at 10.51.33.jpeg": 9419,
	"./WhatsApp Image 2024-09-16 at 10.51.34.jpeg": 3258,
	"./WhatsApp Image 2024-09-16 at 10.51.35.jpeg": 3105,
	"./WhatsApp Image 2024-09-16 at 10.51.44 (1).jpeg": 7887,
	"./WhatsApp Image 2024-09-16 at 10.51.44 (2).jpeg": 8096,
	"./WhatsApp Image 2024-09-16 at 10.51.44.jpeg": 6601,
	"./WhatsApp Image 2024-09-16 at 10.51.45 (1).jpeg": 9884,
	"./WhatsApp Image 2024-09-16 at 10.51.45.jpeg": 4402,
	"./WhatsApp Image 2024-09-16 at 10.51.46 (1).jpeg": 9909,
	"./WhatsApp Image 2024-09-16 at 10.51.46 (2).jpeg": 349,
	"./WhatsApp Image 2024-09-16 at 10.51.46.jpeg": 7999
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8528;